// Escape text for interpolation into an HTML string (print windows, letters).
// Anything a customer or an import can set — names, addresses, notes, invoice
// numbers — must go through this before it lands in markup.
export const escapeHtml = (v) =>
  String(v ?? '').replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export default escapeHtml;
